import React from 'react';

interface RepickFileButtonProps {
  text: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const RepickFileButton: React.FC<RepickFileButtonProps> = ({ text, onChange }) => (
  <button className="retry-btn" aria-label={text}>
    <svg viewBox="0 0 36 36" focusable="false" aria-hidden="true">
      <title>{text}</title>
      <circle cx="18" cy="18" r="18" />
      <path
        d="M25.2,15a8.34,8.34,0,0,0-1.55-2.41C23.09,12,20.76,9.87,20,11.15a.53.53,0,0,0-.1.2c-.26.83.64,1.36,1.19,1.72a6.14,6.14,0,0,1,1.85,1.73A5.79,5.79,0,0,1,23.86,18a5.86,5.86,0,1,1-8.81-5v3.14a1,1,0,0,0,1,1h0a1,1,0,0,0,1-1V10.25H11.17a1,1,0,0,0-1,1v0a1,1,0,0,0,1,1h1.66A7.77,7.77,0,1,0,25.2,15Z"
      />
    </svg>
    <input
      id={`repick-file-${text}`}
      type="file"
      onChange={onChange}
      aria-label={text}
    />
  </button>
);

export default RepickFileButton;
